import { useState, useEffect } from 'react'

/**
 * Provides an Array with the current {width} and {height} of the viewport.
 * @returns an Array of numbers [width, height].
 */
const useDeviceSize = () => {
      // Lazy initializers read current window size once — no need for setState inside effect
      const [width, setWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 0)
      const [height, setHeight] = useState(() => typeof window !== 'undefined' ? window.innerHeight : 0)

      useEffect(() => {
            const handleWindowResize = () => {
                  setWidth(window.innerWidth);
                  setHeight(window.innerHeight);
            }
            window.addEventListener('resize', handleWindowResize);
            return () => window.removeEventListener('resize', handleWindowResize);
      }, []);

      return [width, height]

}

export default useDeviceSize